import {ComponentClassName} from "@dp-instant/ui";
import {apiClient} from "@game/api/ApiClient";
import {Images} from "@game/ui/images";
import cn from "classnames";
import {useState, useEffect} from "preact/hooks";
import "./StarsIndicator.less";

export interface StarsIndicatorProps extends ComponentClassName {}

export const StarsIndicator = ({className}: StarsIndicatorProps) => {
    const [balance, setBalance] = useState(apiClient.hardBalance);

    useEffect(() => {
        const handler = () => setBalance(apiClient.hardBalance);
        window.addEventListener("stars-balance-updated", handler);
        return () => window.removeEventListener("stars-balance-updated", handler);
    }, []);

    const digits = String(balance).length;
    const digitClass = digits >= 5 ? `f${Math.min(digits, 9)}-digits` : "";

    return (
        <div className={cn(className)}>
            <div className={cn("stars-indicator__total", digitClass)}>{balance}</div>
            <div className="stars-indicator__icon"><Images.Star /></div>
        </div>
    );
};
